<template>
  <v-flex xs12 px-3 style="flex-basis: auto">
    <v-text-field
      label="Search Term"
      clearable
      append-icon="mdi-magnify"
      v-model="search"
    ></v-text-field>
  </v-flex>
</template>

<script>
export default {
  name: "GlossarySearch",
  props: {
    value: { type: String, default: "" },
    showSearch: { type: Boolean, default: true }
  },
  data() {
    return {
      search: this.value,
      debounce: null
    }
  },
  beforeUnmount() {
		this.clearDebounce()
  },
  watch: {
    search(value) {
      this.search = value

			this.clearDebounce()

			if (!this.search) {
				this.$emit("input", this.search)
				return
			}

      this.debounce = setTimeout(() => {
        this.$emit("input", this.search)
      }, 300)
    }
  },
	methods: {
		clearDebounce() {
			if (this.debounce) clearTimeout(this.debounce)
		}
	}
}
</script>
